// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  serverUrl: 'https://2n481x1yyi.execute-api.us-east-1.amazonaws.com',
  baseHref: '/',
  endpoint: 'lambda',
  cognitoClientId: '2diluh4volj3k6oehrf1umc4v8',
  cognitoUrl: 'https://glm-migration.auth.us-east-1.amazoncognito.com',
  openIdPlatformUrl: 'https://loftwareloginsandbox.b2clogin.com/loftwareloginsandbox.onmicrosoft.com/b2c_1a_loftware_ms_g_signupsignin/oauth2'
};



//6acc8f1a-12ea-422b-9135-c02ae0752ec6
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
